import React, { Fragment, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import Text from 'ui/Text'

import Button from 'ui/controls/Button'
import { BACKGROUNDS } from 'themes'
import arrowRight from 'icons/arrow_right.svg'
import mobilePay from 'icons/mobile_pay.png'
import Icon from 'ui/Icon'
import getTexts from 'utils/localization'

const StyledIcon = styled(Icon)`
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
`
const ApplePayBtn = styled.button`
    padding: 0;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    margin: 10px auto;
    border: none;
    height: 50px;
    ${(props) =>
        props.disabled &&
        css`
            opacity: 0.35;
            cursor: not-allowed;
        `};

    apple-pay-button {
        display: inline-block;
        pointer-events: none;
        min-height: 32px;
        max-height: 50px;
        --apple-pay-button-width: 100%;
        --apple-pay-button-height: 50px;
        --apple-pay-button-border-radius: 5px;
        --apple-pay-button-padding: 0px;
    }
`

const t = getTexts()

const PaymentType = ({
    amount,
    onSubmitClick,
    setPayType,
    onApplePayClick,
    userId,
}) => {
    const [minDeposit, setMinDeposit] = useState(t.minDeposit)
    const [applePayAvailable, setApplePayAvailable] = useState(false)

    useEffect(() => {
        try {
            const supportsApplePay =
                window.ApplePaySession && ApplePaySession.canMakePayments()

            setApplePayAvailable(!!supportsApplePay)
        } catch (e) {
            onsole.warn('ApplePay check failed:', e)
        }
    }, [])

    useEffect(
        () => {
            if (userId === 181105) {
                setMinDeposit(t.minDepositForTest)
            }
        },
        [userId]
    ) // set min deposit for test user

    return (
        <Fragment>
            <Text
                size="x05"
                align="center"
                block
                grey
                width="100%"
                margin={applePayAvailable ? '30px auto 0' : '50px auto 0'}
            >
                {t.userArea.deposit.bottom}
            </Text>
            <Button
                accent
                position="relative"
                rounded="5px"
                disabled={amount < minDeposit}
                padding="15px 0"
                fontSize="14px"
                block
                width="100%"
                onClick={() => {
                    setPayType('card')
                    setTimeout(() => {
                        onSubmitClick()
                    }, 100)
                }}
            >
                {t.userArea.deposit.proceedCard}
                <StyledIcon height="12px" width="8px" src={arrowRight} />
            </Button>
            <Button
                white
                position="relative"
                rounded="5px"
                disabled={Number(amount) < minDeposit}
                padding="10px 0"
                fontSize="14px"
                block
                width="100%"
                onClick={() => {
                    setPayType('mobilePay')
                    setTimeout(() => {
                        onSubmitClick()
                    }, 100)
                }}
            >
                <img
                    src={mobilePay}
                    alt="MovilePay"
                    style={{ height: '35px', verticalAlign: 'middle' }}
                />
                <StyledIcon
                    color={BACKGROUNDS.grey}
                    height="12px"
                    width="8px"
                    src={arrowRight}
                />
            </Button>
            {applePayAvailable ? (
                <ApplePayBtn
                    disabled={Number(amount) < minDeposit}
                    onClick={() => {
                        setPayType('applePay')
                        onApplePayClick()
                    }}
                >
                    <apple-pay-button
                        buttonstyle="white"
                        type="plain"
                        locale="da-DK"
                    />
                </ApplePayBtn>
            ) : null}
        </Fragment>
    )
}

export default PaymentType
